import { Instance, SnapshotOut, types } from "mobx-state-tree"

export const BaseModelStoreProps = {
  loading: types.maybeNull(types.boolean),
  progress: types.maybeNull(types.number),
  needRefresh: types.maybeNull(types.boolean),

  pushIdQueue: types.optional(types.frozen(), {}),
  error: types.maybeNull(types.frozen()),
}

/**
 * Model description here for TypeScript hints.
 */
export const BaseModelStoreModel = types
  .model("BaseModelStore")
  .props(BaseModelStoreProps)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars

type BaseModelStoreType = Instance<typeof BaseModelStoreModel>
export interface BaseModelStore extends BaseModelStoreType {}
type BaseModelStoreSnapshotType = SnapshotOut<typeof BaseModelStoreModel>
export interface BaseModelStoreSnapshot extends BaseModelStoreSnapshotType {}
export const createBaseModelStoreDefaultModel = () => types.optional(BaseModelStoreModel, {})
